/**
 * Recommended Products Handler
 * Handles API calls for Shopify recommendations engine
 */
document.addEventListener('DOMContentLoaded', function() {
  const recommendedSections = document.querySelectorAll('.js-RecommendedProducts');
  
  recommendedSections.forEach((section) => {
    const productId = section.dataset.productId;
    const sectionId = section.dataset.sectionId;
    const limit = section.dataset.limit || '8';
    
    if (productId && sectionId) {
      loadRecommendations(section, productId, sectionId, limit);
    }
  });
});

async function loadRecommendations(section, productId, sectionId, limit) {
  try {
    const apiUrl = `/recommendations/products?section_id=${sectionId}&limit=${limit}&product_id=${productId}&intent=related`;
    
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const html = await response.text();
    
    // Parse the HTML to extract just the section
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const sectionElement = doc.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (sectionElement) {
      section.outerHTML = sectionElement.outerHTML;
      
      // Re-initialize Swiper if available
      const newCarousel = document.querySelector('.js-ProductCarousel_Carousel');
      if (newCarousel && window.Swiper) {
        new Swiper(newCarousel, {
          loop: true,
          watchSlidesProgress: true,
          slidesPerView: 1.6,
          centeredSlides: true,
          initialSlide: 1,
          spaceBetween: 0,
          speed: 500,
          slideClass: "js-ProductCarousel_Slide",
          breakpoints: { 
            768: { slidesPerView: 2.4 }, 
            960: { slidesPerView: 4.3 } 
          },
          navigation: { 
            nextEl: ".js-ProductCarousel_Next", 
            prevEl: ".js-ProductCarousel_Prev" 
          }
        });
      }
    } else {
      showNoRecommendationsMessage(section);
    }
  } catch (error) {
    showErrorMessage(section);
  }
}

function showNoRecommendationsMessage(section) {
  const carouselItems = section.querySelector('.car-Carousel_Items');
  if (carouselItems) {
    carouselItems.innerHTML = `
      <div class="car-Carousel_Item js-ProductCarousel_Slide" data-index="0">
        <div style="padding: 2rem; text-align: center; color: #666;">
          <p>No recommendations available at this time.</p>
        </div>
      </div>
    `;
  }
}

function showErrorMessage(section) {
  const carouselItems = section.querySelector('.car-Carousel_Items');
  if (carouselItems) {
    carouselItems.innerHTML = `
      <div class="car-Carousel_Item js-ProductCarousel_Slide" data-index="0">
        <div style="padding: 2rem; text-align: center; color: #666;">
          <p>Unable to load recommendations.</p>
        </div>
      </div>
    `;
  }
}
